import { Deserializable } from '../deserializable';

export class MediaInfo implements Deserializable {
    
    public entityId: number;
    public entityType: string;
    public name: string;
    public fileName: string;
    public fileType: string;
    public tag: string;
    public mimeType: string;
    public version: number = 1;
    public createdBy: number;
    public data: string;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
      }
}